import {Brands} from '../../libs/types/src';
import {brandConfig} from '../../libs/ui/src';
import AluraLogoImage from './img/alura.png';
import BreachLogoImage from './img/breach.svg';
import CueGrowthLogoImage from './img/cueGrowth.png';
import InfiniteLogoImage from './img/infinite.png';
import LeadokuLogoImage from './img/leadoku.png';

export default function getLogo() {
  switch (brandConfig.brand) {
    case Brands.LEADOKU:
      return LeadokuLogoImage;
    case Brands.INFINITE:
      return InfiniteLogoImage;
    case Brands.BREACH:
      return BreachLogoImage;
    case Brands.ALURA:
      return AluraLogoImage;
    default:
      return CueGrowthLogoImage;
  }
};
